'use client'
import { SDKApi, Configuration } from '@dynamic-labs/sdk-api-core';
import { FetchService } from '@dynamic-labs/utils';
import { getMinAuthToken, isCookieEnabled } from './helpers.js';
import ApiEndpoint from './ApiEndpoint.js';
import { VERSION, API_VERSION } from './version.js';

const sdkApi = () => {
    const baseUrl = process.env.API_BASE_URL ||
        process.env.NX_API_BASE_URL ||
        'https://app.dynamic.xyz/api/v0';
    ApiEndpoint.setBaseUrl(baseUrl);
    const settings = {
        basePath: ApiEndpoint.getBaseUrl(),
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const minJwt = getMinAuthToken();
    if (minJwt) {
        settings.headers.Authorization = `Bearer ${minJwt}`;
    }
    const credentials = isCookieEnabled()
        ? 'include'
        : undefined;
    settings.headers['x-dyn-version'] = `WalletKit/${VERSION}`;
    settings.headers['x-dyn-api-version'] = `API/${API_VERSION}`;
    return new SDKApi(new Configuration(Object.assign(Object.assign({}, settings), { credentials, fetchApi: FetchService.fetch })));
};

export { sdkApi };
